import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ForgotPasswordFormComponent } from '../../../components/forgot-password-form/forgot-password-form.component';
import { ResetPasswordFormComponent } from '../../../components/reset-password-form/reset-password-form.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    RouterModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    ForgotPasswordFormComponent,
    ResetPasswordFormComponent
  ]
})
export class ResetPasswordPage implements OnInit {
  resetCodeParam: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const hasParam = this.route.snapshot.queryParamMap.has('resetCode');
    this.resetCodeParam = hasParam ? this.route.snapshot.queryParamMap.get('resetCode') : null;

    if (this.resetCodeParam) {
      document.title += ' - Wachtwoord herstellen';
    } else {
      document.title += ' - Wachtwoord vergeten';
    }
  }
}
